import React, { useState } from "react";
import APIS from "../../constant/Endpoint";
import TextCard from "../Reusable/TextCard";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import useGetHook from "../../customHooks/useGetHook";
import CardSkeleton from "../Reusable/CardSkeleton";
import OrderList from "./OrderList";
import StatusCard from "./StatusCard";

const StatusList = (props: any) => {
  const {
    paynentMethodData,
    filterParams,
    register,
    getValue,
    setValue,
    date,
    isPaymentMethodLoading,
  } = props;
  const [cardFilterParms, setCardFilterParms] = useState<any>({});
  const [activeCard, setActiveCard] = useState("");

  const [selectedPaymentMethod, setSelecteddPaymentMethod] = useState(null);
  const handleOnClickGrid = (key: string, name: string) => {
    setCardFilterParms(key);
    setActiveCard(name);
  };

  const {
    data: statusData,
    isLoading,
    isRefetching,
  } = useGetHook({
    queryKey: ["status", JSON.stringify(filterParams)],
    url: `${APIS.STATUS}overview/`,
    params: {
      ...filterParams,
      is_active: true,
    },
  });

  return (
    <>
      {isPaymentMethodLoading ? (
        <div className={tw`grid grid-cols-4 gap-x-6  `}>
          {Array.from({ length: 4 }).map((_, index) => {
            return <CardSkeleton key={index} />;
          })}
        </div>
      ) : (
        <div
          className={tw`grid grid-cols-4 sm:grid-cols-4 md:grid-cols-4 xl:grid-cols-4 gap-x-8`}
        >
          {paynentMethodData?.map((item: any, index: number) => (
            <React.Fragment key={index}>
              <TextCard
                title={item?.name}
                slug={item?.id}
                setSelecteddPaymentMethod={setSelecteddPaymentMethod}
                count={item?.order_count}
                amount={item?.delivery_charge}
                register={register("paymeny_method")}
                setValue={setValue}
                name={"paymeny_method"}
                selectedPaymentMethod={selectedPaymentMethod}
              />
            </React.Fragment>
          ))}
        </div>
      )}

      {isLoading || isRefetching ? (
        <div className={tw`grid grid-cols-4 gap-x-6  `}>
          {Array.from({ length: 8 }).map((_, index) => {
            return <CardSkeleton key={index} />;
          })}
        </div>
      ) : (
        <div className={tw`grid grid-cols-4 gap-x-8 `}>
          {statusData?.map((item: any, index: number) => (
            <StatusCard
              key={index}
              item={item}
              onClick={handleOnClickGrid}
              selectedCardItems={cardFilterParms}
              activeCard={activeCard}
            />
          ))}
        </div>
      )}

      <OrderList
        filterParams={{
          ...filterParams,
          created__range: date,
          payment_method: selectedPaymentMethod,
          delivery_status__in: cardFilterParms,
        }}
      />
    </>
  );
};

export default StatusList;
